import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1L11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12L13 1ZM7.08357 4.84287C7.54908 4.54568 7.68552 3.92739 7.38832 3.46188C7.09113 2.99638 6.47284 2.85994 6.00734 3.15713C3.00063 5.07673 1 8.40911 1 12.2082C1 18.1881 5.94481 23 12 23C18.0552 23 23 18.1881 23 12.2082C23 8.40911 20.9994 5.07673 17.9927 3.15713C17.5272 2.85994 16.9089 2.99638 16.6117 3.46188C16.3145 3.92739 16.4509 4.54568 16.9164 4.84287C19.3828 6.41751 21 9.13256 21 12.2082C21 17.0441 16.9905 21 12 21C7.00949 21 3 17.0441 3 12.2082C3 9.13256 4.61718 6.41751 7.08357 4.84287Z"
  }));
});
var NavigationLogout = AbstractIcon.withComponent(Icon);
NavigationLogout.displayName = 'NavigationLogout';
export default NavigationLogout;